module.exports = __webpack_public_path__ + "static/portal-fc75a46cae3492c2b0c870b18282a9a1.jpg";